import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ClientesRepetidos = ({
    clientesRepetidos,
    setIdClienteAkasiaACombinar,
    setShowModalCombinarClientes
}) => {
    const iconName = icon({ name: 'code-merge', style: "solid" });

    if (clientesRepetidos.length === 0) {
        return null;
    }

    return (
        <Col lg={12}>
            <Card>
                <Card.Header>
                    <Col>
                        <h5 className="mb-0">Posible clientes repetidos</h5>
                    </Col>
                </Card.Header>

                <Card.Body className="border-top fs--1">
                    <Row className="p-2">
                        {clientesRepetidos.map((cliente, index) => {
                            return (
                                <Col className="p-0 col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-2" key={index}>
                                    <Row>
                                        <Col className="col-1">
                                            <FontAwesomeIcon
                                                className="me-1"
                                                icon={icon({ name: 'circle-exclamation', style: "solid" })}
                                                style={{ color: "#fab005", fontSize: "2.5em" }}
                                            />
                                        </Col>
                                        <Col className="col-6">
                                            <Row>
                                                <Col className="col-12">
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip style={{ position: 'fixed' }}>
                                                                Ver info de este cliente
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <Link
                                                            className="align-content-center"
                                                            to={"/clientes/detalle/" + cliente.idClienteAkasia}
                                                        >
                                                            <span className="ms-1 text-center">
                                                                {"Cliente repetido: " + cliente.idClienteAkasia}
                                                            </span>
                                                        </Link>
                                                    </OverlayTrigger>
                                                </Col>

                                                <Col className="col-12">
                                                    {cliente.bNombre == 1 && (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip style={{ position: 'fixed' }}>
                                                                    Cliente con mismo nombre
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <FontAwesomeIcon icon="user" className="ms-2" />
                                                        </OverlayTrigger>
                                                    )}
                                                    {cliente.bTelefono == 1 && (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip style={{ position: 'fixed' }}>
                                                                    Cliente con mismo telefono
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <FontAwesomeIcon icon="phone" className="ms-2" />
                                                        </OverlayTrigger>
                                                    )}
                                                    {cliente.bCorreo == 1 && (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip style={{ position: 'fixed' }}>
                                                                    Cliente con mismo correo
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <FontAwesomeIcon icon="envelope" className="ms-2" />
                                                        </OverlayTrigger>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col className="col-2">
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip style={{ position: 'fixed' }}>
                                                        Combinar cliente
                                                    </Tooltip>
                                                }
                                            >
                                                <Button
                                                    className="btn btn-falcon-default btn-md"
                                                    onClick={() => {
                                                        setIdClienteAkasiaACombinar(cliente.idClienteAkasia);
                                                        setShowModalCombinarClientes(true);
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon={iconName} />
                                                </Button>
                                            </OverlayTrigger>
                                        </Col>
                                    </Row>
                                </Col>
                            )
                        })}
                    </Row>
                </Card.Body>
            </Card>
        </Col>
    );
};

ClientesRepetidos.propTypes = {
    clientesRepetidos: PropTypes.arrayOf(
        PropTypes.shape({
            idClienteAkasia: PropTypes.number.isRequired,
            bNombre: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
            bTelefono: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
            bCorreo: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
        })
    ).isRequired,
    setIdClienteAkasiaACombinar: PropTypes.func.isRequired,
    setShowModalCombinarClientes: PropTypes.func.isRequired
};

export default ClientesRepetidos;
